import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays the automatic discount-percentage badge
 * on the main product image. Listens for variant update events and swaps
 * in the freshly server-rendered badge for the newly selected variant,
 * mirroring the pattern used by <product-price>.
 */
class ProductDiscountBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector(`product-discount-badge[data-block-id="${this.dataset.blockId}"]`);
    if (!newBadge) return;

    this.replaceWith(newBadge);
  };
}

if (!customElements.get('product-discount-badge')) {
  customElements.define('product-discount-badge', ProductDiscountBadge);
}
